export interface DnsState {
  dhcp: any[],
  servers: any[]
}

const dnsState: DnsState = {
  dhcp: [],
  servers: []
};

const dnsMutations: CommonMutationTree<DnsState> = {
  FETCH_DNS_SUCCESS(state, { dhcp, servers }): void {
    state.dhcp = dhcp;
    state.servers = servers.map(server => ({
      ip: server,
      dhcp: dhcp.indexOf(server) !== -1
    }));
  },
  FETCH_DNS_ERROR(state): void {
    state.dhcp = [];
    state.servers = [];
  }
};

const dnsActions: CommonActionTree<DnsState> = {
  FETCH_DNS({ commit }): Promise<FetchResponse> {
    return this.$api.get('/api/v2/dns/')
      .then((response) => {
        commit('FETCH_DNS_SUCCESS', {
          dhcp: response.data.dhcp_nameservers,
          servers: response.data.nameservers
        });
        return response;
      })
      .catch((error) => {
        commit('FETCH_DNS_ERROR', error);
        throw error;
      });
  },
  SAVE_DNS(_, servers): Promise<FetchResponse> {
    return this.$api.put('/api/v2/dns/', {
      nameservers: servers.reduce((result, server) => {
        if (server.dhcp && server.dhcpIp) {
          result.push(server.dhcpIp);
        } else if (!server.dhcp && server.ip) {
          result.push(server.ip);
        }
        return result;
      }, [])
    });
  }
};

export default new class implements CommonStore<DnsState, unknown> {
  name = 'dns';
  state = dnsState;
  mutations = dnsMutations;
  actions = dnsActions;
}();
